import { satisfies as versionSatisfies, coerce as semverCoerce } from "semver";
const deviceVersionRangesForRecover = {
    nanoX: ">=2.1.0",
    nanoSP: ">=1.1.0",
    stax: ">=1.0.0",
    europa: ">=0.0.0",
};
export const isRecoverSupported = (seVersion, modelId) => !!modelId &&
    !!deviceVersionRangesForRecover[modelId] &&
    !!versionSatisfies(semverCoerce(seVersion) || seVersion, deviceVersionRangesForRecover[modelId]);
//# sourceMappingURL=isRecoverSupported.js.map